const line_24 = require("assets/v1.1/icons/Core/SignOut/line_24.svg");

export const SignOut = {
  Line: { 24: line_24 },
};
